module.exports = __webpack_public_path__ + "static/breath-video-frame-c569168988829b6727fdcfd1710e6f26.png";